'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/Button.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  className: _react2.default.PropTypes.string,
  handleClick: _react2.default.PropTypes.func,
  disabled: _react2.default.PropTypes.bool,
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
  isLoading: _react2.default.PropTypes.bool,
  tagName: _react2.default.PropTypes.string,
  spinnerColor: _react2.default.PropTypes.string,
  block: _react2.default.PropTypes.bool,
  flat: _react2.default.PropTypes.bool
};

var Button = function (_BcReactComponent) {
  _inherits(Button, _BcReactComponent);

  function Button(props) {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.bindAll('handleClick');
    return _this;
  }

  _createClass(Button, [{
    key: 'handleClick',
    value: function handleClick(e) {
      if (this.props.isLoading) {
        e.preventDefault();
        return;
      }
      if (this.props.handleClick) {
        e.preventDefault();
        this.props.handleClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          spinnerColor = _props.spinnerColor,
          block = _props.block,
          flat = _props.flat,
          isLoading = _props.isLoading,
          Tag = _props.tagName,
          props = _objectWithoutProperties(_props, ['className', 'children', 'spinnerColor', 'block', 'flat', 'isLoading', 'tagName']);

      delete props.handleClick;

      return _react2.default.createElement(
        Tag,
        _extends({}, props, { onClick: this.handleClick, className: Button.getButtonClassName(className, block, flat) }),
        isLoading ? _react2.default.createElement(_baseIcons.Spinner, { color: spinnerColor }) : children
      );
    }
  }], [{
    key: 'getButtonClassName',
    value: function getButtonClassName() {
      var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var isBlock = arguments[1];
      var isFlat = arguments[2];

      var block = isBlock ? 'btn-block' : '';
      var flat = isFlat ? 'btn-flat' : '';
      return 'cp-btn btn ' + block + ' ' + flat + ' ' + classes;
    }
  }]);

  return Button;
}(_baseBcReactComponent2.default);

Button.propTypes = propTypes;
Button.defaultProps = {
  tagName: 'button'
};
Button.displayName = 'Button';

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/buttons/lib/components/button/components/Button.component.js
// module id = 214
// module chunks = 0 1 3 4 5